export const test = {
  production: false,
  name: "test",
  useEmulators: false,
  commit: "testcommit",
  firebase: {
    apiKey: 'AIzaSyBC8heLHwUvLKxj0SrvDLhaD3TClK8Cs8E',
    authDomain: 'innersight-test.firebaseapp.com',
    databaseURL: 'https://innersight-test.firebaseio.com',
    projectId: 'innersight-test',
    storageBucket: 'innersight-test.appspot.com',
    messagingSenderId: '661044276461',
    appId: '',
    measurementId: '',
  },
  urls: {
    segue: "https://segue-test.web.app",
    segui: "https://segui-test.web.app",
    xview: "https://xview-test.web.app",
    console: "https://innerconsole-test.web.app",
    meshBaseUrl: 'https://storage.googleapis.com/3d-innersight-test/models',
  }
};
